import { Header } from '../../components/header/header';
import { IntroSection } from '../../components/intro-section/intro-section';
import { UpcomingEvents } from '../../components/upcoming-events/upcoming-events';
import { MissedLastEvent } from '../../components/missed-last-event/missed-last-event';
import { WhatToExpect } from '../../components/what-to-expect/what-to-expect';
import { ExcitingTopics } from '../../components/existing-topics/existing-topics';
import { WhyAttend } from '../../components/why-attend/wht-attend';
import { FeedbackSection } from '../../components/feedback/feedback';
import { RecordingsPage } from '../recordings-page/recordings-page';
export const LandingPage = () => {
  return (
    <div>
      <Header />
      <IntroSection />
      <WhatToExpect />
      <UpcomingEvents />
      <ExcitingTopics />
      {/* <MissedLastEvent /> */}
      <RecordingsPage/>
      <WhyAttend />
      <FeedbackSection />
    </div>
  );
};
